import EmailPermissionForm from "./form"
export default EmailPermissionForm;